var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 0.316406H4.33329C2.04163 0.316406 0.166626 2.19141 0.166626 4.48307V41.9831L8.49996 33.6497H37.6666C39.9583 33.6497 41.8333 31.7747 41.8333 29.4831V4.48307C41.8333 2.19141 39.9583 0.316406 37.6666 0.316406ZM37.6666 29.4831H8.49996L4.33329 33.6497V4.48307H37.6666V29.4831ZM10.5833 14.8997H14.75V19.0664H10.5833V14.8997ZM18.9166 14.8997H23.0833V19.0664H18.9166V14.8997ZM27.25 14.8997H31.4166V19.0664H27.25V14.8997Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconSms);
export default __webpack_public_path__ + "static/media/TH-Icon-SMS.e38e841c8c22fa7a76464763c2088b48.svg";
export { ForwardRef as ReactComponent };